import { CommonModule } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { FormControl, FormsModule, ReactiveFormsModule, UntypedFormGroup } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatOptionModule } from '@angular/material/core';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { MatStepperModule } from '@angular/material/stepper';
import { MarkdownPipe } from '../../../../shared';
import { DtoSelfServiceFormData } from '../../../../core';
import { IKeyDisplayValuePair, ReferenceCategoryType, ReferenceDocumentType } from '@common';
import { MatRadioModule } from '@angular/material/radio';

@Component({
  selector: 'app-content-step',
  imports: [
    CommonModule,
    FormsModule,
    MarkdownPipe,
    MatButtonModule,
    MatFormFieldModule,
    MatOptionModule,
    MatRadioModule,
    MatSelectModule,
    MatStepperModule,
    ReactiveFormsModule
  ],
  templateUrl: './content-step.component.html',
  styleUrls: ['./content-step.component.scss', '../self-service-form.step.scss']
})
export class ContentStepComponent implements OnInit {
  //#region Component Inputs --------------------------------------------------
  @Input({ required: true }) stepForm!: UntypedFormGroup;
  @Input({ required: true }) formData!: DtoSelfServiceFormData;
  @Input({ required: true }) infoPageSelectItems!: Array<IKeyDisplayValuePair<ReferenceCategoryType>>;
  @Input({ required: true }) documentTypeSelectitems!: Array<IKeyDisplayValuePair<ReferenceDocumentType>>;
  @Input({ required: true }) brand!: boolean;
  //#endregion

  //#region Private Fields ----------------------------------------------------
  private readonly longLabels: Map<ReferenceCategoryType, string>;
  //#endregion

  //#region Protected Fields --------------------------------------------------
  protected infoPageDisabled: boolean;
  protected readonly brandValues: Array<IKeyDisplayValuePair<string>>;
  //#endregion

  //#region Getters -----------------------------------------------------------
  protected get infoPageDescription(): string {
    return (
      Array.isArray(this.formData.infoPageDescription)
        ? this.formData.infoPageDescription.join('')
        : this.formData.infoPageDescription
    )
      .replace('${agile}', this.longLabels.get('agile') || 'Agile')
      .replace('${se}', this.longLabels.get('se') || 'Software Engineering')
      .replace('${training}', this.longLabels.get('training') || 'Training and Workshops');
  }
  //#endregion

  //#region Constructor & C° --------------------------------------------------
  public constructor() {
    this.longLabels = new Map<ReferenceCategoryType, string>();
    this.infoPageDisabled = false;
    this.brandValues = [
      { key: 'dec', displayValue: 'der-e-coach' },
      { key: 'aiasom', displayValue: 'Agile is a state of mind' },
      { key: 'pers', displayValue: 'Personal' }
    ];
  }

  public ngOnInit(): void {
    this.infoPageSelectItems.forEach((item: IKeyDisplayValuePair<ReferenceCategoryType>) =>
      this.longLabels.set(item.key, item.displayValue)
    );
    const contentControl = this.stepForm.get('contentControl') as FormControl<
      IKeyDisplayValuePair<ReferenceDocumentType>
    >;
    const infoPageControl = this.stepForm.get('infoPageControl');
    contentControl.valueChanges.subscribe((value: IKeyDisplayValuePair<ReferenceDocumentType>) => {
      if (value.key == 'full') {
        infoPageControl.enable();
      } else {
        infoPageControl.disable();
      }
      this.infoPageDisabled = value.key == 'one-pagers';
    });
  }
  //#endregion
}
